import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Permission } from '../config/roles.config';

/**
 * Route guard for pages that need a role (XD E2): `canActivate: [AuthGuard, roleGuard('shop')]`.
 * Someone without the permission goes back to the home page. The API checks the role as well.
 */
export function roleGuard(permission: Permission): CanActivateFn {
  return () => {
    const authService = inject(AuthService);
    if (authService.can(permission)) {
      return true;
    }
    return inject(Router).createUrlTree(['/home']);
  };
}
